document.addEventListener('DOMContentLoaded', () => {
  const body = document.querySelector('body');
  const closeButtons = document.querySelectorAll('.btn--close-popup');
  const popupBackgrounds = document.querySelectorAll('.side-popup__background');
  const links = document.querySelectorAll('a[href^="#"]');
  const qrcodeElements = document.querySelectorAll('#qrcode');

  const isMobile = navigator.userAgent.match('Mobile') !== null;

  closeButtons.forEach(button => {
    button.addEventListener('click', handleCloseButtonClick);
  });

  popupBackgrounds.forEach(background => {
    background.addEventListener('click', handleCloseButtonClick);
  });

  links.forEach(link => {
    link.addEventListener('click', handleLinkClick);
  });

  function handleCloseButtonClick(event) {
    const clickedPopup = event.currentTarget.closest('.side-popup');
    closePopup(clickedPopup);
  }

  function handleLinkClick(event) {
    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    if (!targetElement || !targetElement.classList.contains('side-popup')) {
      return;
    }

    if (isMobile) {
      handleMobileRedirect(targetElement);
    } else {
      openPopup(targetElement);
    }
  }

  function handleMobileRedirect(targetElement) {
    const qrCodeElement = targetElement.querySelector('#qrcode');
    const dataLink = qrCodeElement.getAttribute('data-link');
    if (dataLink) {
      window.location.href = dataLink; // Redireciona para o link
    }
  }

  function closePopup(popup) {
    popup.classList.remove('open');
    popup.classList.add('closing');
    body.style.overflow = 'auto';

    setTimeout(() => {
      popup.classList.remove('closing');
      window.location.hash = '';
    }, 200);
  }

  function openPopup(popup) {
    requestAnimationFrame(() => {
      popup.classList.add('open');
      body.style.overflow = 'hidden';
    });
  }

  // Gerar QRCodes para cada elemento com a id qrcode e converter canvas para img
  qrcodeElements.forEach(element => {
    const link = element.getAttribute('data-link');
    const qrCode = new QRCode(element, {
      width: 228,
      height: 228,
      text: link,
      dotScale: 0.5, // Escala dos pontos (0.5 para pequenos pontos)
      quietZone: 10, // Espaço em branco ao redor do QR Code
      // Personalização dos pontos do QR Code
      colorDark: '#000000', // Cor dos pontos escuros
      colorLight: '#ffffff', // Cor dos pontos claros
      PO: '#000000', // Cor do ponto de alinhamento (1)
      PI: '#000000', // Cor do ponto de alinhamento (2)
      PO_TL: '#000000', // Cor do ponto de alinhamento (top left)
      PI_TL: '#000000', // Cor do ponto de alinhamento (top left interior)
      PO_TR: '#000000', // Cor do ponto de alinhamento (top right)
      PI_TR: '#000000', // Cor do ponto de alinhamento (top right interior)
      PO_BL: '#000000', // Cor do ponto de alinhamento (bottom left)
      PI_BL: '#000000', // Cor do ponto de alinhamento (bottom left interior)
      AI: '#FFFFFF', // Cor do ponto de alinhamento alternativo
      AO: '#FFFFFF', // Cor do ponto de alinhamento alternativo
      timing_H: '#FFFFFF', // Cor da linha de sincronização (horizontal)
      timing_V: '#FFFFFF', // Cor da linha de sincronização (vertical)
      logoBackgroundTransparent: true, // Fundo transparente para o logo
    });

    qrCode.makeCode(link); // Gera o QR Code

    setTimeout(() => {
      const canvas = element.querySelector('canvas');
      if (canvas) {
        const img = document.createElement('img');
        img.src = canvas.toDataURL('image/png');
        img.width = canvas.width;
        img.height = canvas.height;

        // Substitui o canvas pelo elemento img
        element.innerHTML = '';
        element.appendChild(img);
      }
    }, 100); // Ajuste o tempo de delay se necessário
  });
});
